export default __webpack_public_path__ + "static/media/cursor-image.ccf70b61.svg";